import React, { useState } from "react";
import { PRODUCT_MOCKUP, PRODUCT_MOCKUP_FALLBACK } from "../data/visuals";
type KitMockupProps = {
  decorative?: boolean;
  className?: string;
};
export function KitMockup({
  decorative = false,
  className = ""
}: KitMockupProps) {
  const [src, setSrc] = useState(PRODUCT_MOCKUP);
  const onError = () => {
    if (src !== PRODUCT_MOCKUP_FALLBACK) setSrc(PRODUCT_MOCKUP_FALLBACK);
  };
  return <img className={`kit-mockup-img ${decorative ? "is-small" : ""} ${className}`} src={src} onError={onError} alt={decorative ? "" : "Customer Service Team Training: 10 ready-to-run sessions plus 5 bonus resources, digital PDF bundle"} width={1024} height={1536} decoding="async" loading={decorative ? "lazy" : "eager"} data-id="element-86" data-mp="1t5tbw4rva2ll" />;
}